import React from "react";

import "./index.scss";

const CalenderIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" className="parentCalender" disabled={props.disabled} viewBox="0 0 30 30">
    <g xmlns="http://www.w3.org/2000/svg">
      <polygon
        className="calendar-polygon"
        points="23.24 24 8.76 24 8.76 9.51 11.02 9.51 11.02 8 11.91 8 11.91 9.51 20.09 9.51 20.09 8 20.98 8 20.98 9.51 23.24 9.51 23.24 24"
      />
      <line className="calendar-line" x1="9.22" y1="13.81" x2="22.78" y2="13.81" />
    </g>
  </svg>
);

export default CalenderIcon;
